export function triggerDTMEvent(eventName) {
    if (typeof window._satellite !== 'undefined' && typeof window._satellite.initialized !== 'undefined' && window._satellite.initialized === true) {
        window._satellite.track(eventName);
    }
}

function removeFalsyValues(obj) {
    Object.keys(obj).forEach(key => {
        if (obj[key] == null) delete obj[key];
    });
    return obj;
}

// 2nd param set true if you want to merge with DTM object
export function setWindowDtm(dtm, mergeWindowDtm = false) {
    if (typeof window !== 'undefined') {
        let eventName = '';
        if (dtm.event) {
            eventName += dtm.event;
            delete dtm.event;
        }
        let newDtm = {};
        if (mergeWindowDtm) {
            newDtm = { ...window.dtm, ...dtm };
        } else {
            newDtm = { ...window.persistDtm, ...dtm };
        }
        window.dtm = removeFalsyValues(newDtm);
        const { deviceType, site, loginStatus, customerID, email, mobileNumber, lastPurchaseDate, platform } = newDtm;
        window.persistDtm = removeFalsyValues({ deviceType, site, loginStatus, customerID, email, mobileNumber, lastPurchaseDate, platform });
        if (eventName) {
            triggerDTMEvent(eventName);
        }
    }
}

export function getDTMCategory(path) {
    let dtmCMSCategory = '';
    if (path.indexOf('premium-eyeglasses') > -1) {
        dtmCMSCategory = 'premium-eyeglasses';
    } else if (path.indexOf('premium-sunglasses') > -1) {
        dtmCMSCategory = 'premium-sunglasses';
    } else if (path.indexOf('eyeglasses.html') > -1) {
        dtmCMSCategory = 'eyeglasses';
    } else if (path.indexOf('sunglasses.html') > -1) {
        dtmCMSCategory = 'sunglasses';
    } else if (path.indexOf('contact-lenses.html') > -1) {
        dtmCMSCategory = 'contact-lenses';
    }
    return dtmCMSCategory;
}
